import React from "react";
import Marquee from "react-fast-marquee";
import { useI18n } from "../i18n/I18nContext";

const BRANDS = ["WORLD GYM", "BIRDMAN", "GORILLA PUMP", "JOHN LEOPARD", "SLIP RITUAL", "PROSUPPS"];

export default function LogoCarousel() {
  const { t } = useI18n();
  return (
    <section className="py-16 sm:py-20 border-b border-white/5" data-testid="logo-carousel">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center text-[10px] sm:text-xs tracking-[0.4em] text-zinc-500 mb-8 uppercase">
          {t.sponsors.title}
        </div>
      </div>
      <div className="marquee-fade">
        <Marquee gradient={false} speed={40} pauseOnHover>
          {[...BRANDS, ...BRANDS].map((brand, i) => (
            <div
              key={i}
              className="mx-10 sm:mx-16 font-display text-3xl sm:text-5xl tracking-wider text-zinc-500 hover:text-[#FF6B00] transition-colors duration-300 whitespace-nowrap"
              data-testid={`brand-${i}`}
            >
              {brand}
            </div>
          ))}
        </Marquee>
      </div>
    </section>
  );
}
